module.exports = {
  title: "Lingua.community",
  serviceWorker: {
    NEW_VERSION_AVAILABLE: {
      content: "A new version is available!",
    },
    INSTALL_RECOMMENDATION: {
      title: "Application Installation",
      content:
        "Install the Lingua Community app to make using our platform more convenient.",
      iosSteps: `To install app into your device please follow steps described below:<ol class="mt-4"><li class="mb-2"><div>Click "Share"</div><div><img alt="Step 1" class="fill-width" src="/pwa/installation/ios/step1.jpeg"></div><li class="mb-2"><div>Click "Add to Home Screen"</div><div><img alt="Step 2" class="fill-width" src="/pwa/installation/ios/step2.jpeg"></div><li class="mb-2"><div>Click "Add"</div><div><img alt="Step 3" class="fill-width" src="/pwa/installation/ios/step3.jpeg"></div><li class="mb-2"><div>Find application from your "Home Screen"</div><div><img alt="Step 4" class="fill-width" src="/pwa/installation/ios/step4.jpeg"></div></ol>`,
      install: "Install",
    },
  },
  autoMessages: {
    CONNECT: `
    Hi!
    I would like to connect with you.
    `,
    BOOK_LESSON: `
    Hi!
    I would like to book lesson with you.
    `,
  },
  validators: {
    required: "This field is required",
    minValue: "Min value allowed is {value}",
    maxValue: "Max value allowed is {value}",
    minArrayValue: "Min allowed options is {value}",
    maxArrayValue: "Max allowed options is {value}",
    passwordMustMatch: "Password must be matched",
    invalidEmail: "Invalid Email",
    maxLength: "Field should not exceed {length} characters",
    selectAtLeastOne: "Select at least one option",
    firstName: "Name is required",
    lastName: "Last name is required",
    mustSelect: "You must select {length} criterion",
    optionalPrefix: "(opt.)",
  },
  errorMessages: {
    LESSON_NOT_FOUND: "Lesson is not found",
    "Failed to fetch":
      "You have connection issues, please check your internet and try again",
    REQUIRED_DRAGGABLE_MARKED_SYMBOL: "Required draggable marked phrase",
    REQUIRED_DRAGGABLE_MARKED_SYMBOL_MIN_1:
      "Required at least 1 draggable marked phrase",
    REQUIRED_FIELD_MARKED_SYMBOL: "Required field marked phrase",
    REQUIRED_FIELD_MARKED_SYMBOL_MIN_1:
      "Required at least 1 field marked phrase",
    REQUIRED_SYNONYM_MARKED_SYMBOL: "Required synonym marked phrase",
    REQUIRED_REAL_SYNONYM_MARKED_SYMBOL: "Required real synonym marked phrase",
    REQUIRED_FAKE_SYNONYM_MARKED_SYMBOL: "Required fake synonym marked phrase",
    SYNONYM_MARKED_SYMBOL_MUST_BE_1: "Required exactly 1 synonym marked phrase",
    REAL_SYNONYM_MARKED_SYMBOL_MUST_BE_1:
      "Required exactly 1 real synonym marked phrase",
    REQUIRED_FAKE_SYNONYM_MARKED_SYMBOL_MIN_1:
      "Required at least 1 fake synonym marked phrase",
    REQUIRED_REAL_PLACE_MARKED_SYMBOL: "Required real place marked phrase",
    REQUIRED_FAKE_PLACE_MARKED_SYMBOL: "Required fake place marked symbol",
    REAL_PLACE_MARKED_SYMBOL_MUST_BE_1:
      "Required exactly 1 real place marked phrase",
    REQUIRED_FAKE_PLACE_MARKED_SYMBOL_MIN_1:
      "Required at least 1 fake place marked symbol",
    REQUIRED_CORRECT_OR_WRONG_MARKED_SYMBOL:
      "Required correct/wrong marked phrase",
    REQUIRED_CORRECT_OR_WRONG_MARKED_SYMBOL_MIN_1:
      "Required at least 1 correct/wrong marked phrase",
    USER_EMAIL_ALREADY_CREATED:
      "User with this email has been already registered",
    INVALID_PERMISSIONS:
      "The resource you are looking for is not available currently. <br /> It seems the resource has some privacy settings applied.",
  },
  pages: {
    common: {
      profile: "Profile",
      balance: "Balance: <b>${value}</b>",
      visitProfile: "Visit profile",
      profileSettings: "Profile settings",
      logout: "Logout",
      message: "Message",
      connect: "Connect",
      joinToConnect: "Join to connect",
      removeConnection: "Remove",
      pending: "Pending",
      acceptInvitation: "Accept",
      declineInvitation: "Decline",
      filters: "Filters",
      id: "ID",
      cancel: "Cancel",
      add: "Add",
      share: "Share",
      repost: "Repost",
      repostWithYourThoughts: "Repost with your thoughts",
      send: "Send",
      submit: "Submit",
      apply: "Apply",
      save: "Save",
      unsave: "Unsave",
      like: "Like",
      unlike: "Unlike",
      comment: "Comment",
      likes: "Like(s)",
      comments: "Comment(s)",
      login: "Login",
      signIn: "Sign In",
      signUp: "Sign Up",
      create: "Create",
      update: "Update",
      edit: "Edit",
      reset: "Reset",
      close: "Close",
      delete: "Delete",
      loading: "Loading",
      loadMore: "Load More",
      oops: "Oops",
      reload: "Reload",
      copied: "Copied",
      searchAnyPerson: "Search any person",
      typeAnyPersonsName: "Type any person's name",
      noMatchingUsers: "No matching users",
      searchForUsers: "Search for users",
      seeAllResults: "See all results",
      search: "Search",
      show: "Show",
      showMore: "show more",
      showLess: "show less",
      untitled: "Untitled",
      unnamed: "Unnamed",
      copyLink: "Copy link",
      preview: "Preview",
      moveUp: "Move Up",
      moveDown: "Move Down",
      fork: "Save",
      unfork: "Unsave",
      actions: "Actions",
      tabs: {
        main: "Main",
        home: "Home",
        myNetwork: "My Network",
        lessons: "Lessons",
        messages: "Messages",
        materials: "Materials",
        lessonBoards: "Boards",
        notifications: "Notifications",
      },
      download: "Download",
      uploading: "Uploading...",
      next: "Next",
      done: "Done",
      new: "New",
      rename: "Rename",
      back: "Back",
      category: {
        saved: "Saved",
        categories: "Categories",
        title: "Category",
        newTitle: "New Category",
        editTitle: "Edit Category",
        addCategory: "Add Category",
        form: {
          title: "Title",
        },
      },
      linkToShare: "Link to Share",
      select: "Select",
      selected: "Selected",
      nItemsSelected: "{value} item(s) selected",
      more: "More",
    },
    feed: {
      form: {
        content: {
          placeholder: "Write what's on your mind...",
        },
      },
      noFeedsFound: "No feeds found",
      post: "Post",
      photoOrVideo: "Photo / Video",
      addMaterial: "Add material",
      repostDescription: {
        repost: "Instantly bring post to other's feed",
        repostWithYourThoughts: "Create new post with current post",
      },
      copyLinkToPost: "Copy link to post",
      selectUsersToSend: "Select user(s) to send post",
    },
    comment: {
      form: {
        content: {
          commentPlaceholder: "Add a comment...",
          replyPlaceholder: "Add a reply...",
        },
      },
      comment: "Comment",
      noCommentsAddedYet: "No comments added",
      commentNow: "Comment now",
      loadMoreComments: "Load more comments",
      reply: "Reply",
      replyingTo: "Replying to:",
      viewMoreReplies: "View more replies ({value})",
      viewReplies: "View replies ({value})",
    },
    mediaEditor: {
      title: "Editor",
      upload: {
        selectAFileToBegin: "Select a file to begin",
        sharePhotoOrVideoInYourPost: "Share photo or video in your post",
        uploadFromYourDevice: "Upload from your device",
        dragYourFilesHere: "Drag your files here",
        dropYourFileHere: "Drop your file here",
        dropYourFilesHere: "Drop your files here",
      },
    },
    home: {
      leftContainerDescription:
        "The place, where students and teachers from all over the world achieve high results while working with no intermediaries",
      aboutUs: "About us",
      iAmAStudent: "I am a student",
      iAmATeacher: "I am a teacher",
    },
    promo: {
      student: {
        title: "Over 100 professional teachers that people trust",
        description:
          "Students give grades to the teachers for the effectiveness in teaching. Based on the grades, we recommend you the best teachers",
        howEffectiveWasLesson: "How effective was your lesson?",
        submitGrade: "Submit the grade",
        filterData: {
          title: "Answer the questions and we will select the ideal teacher",
          languageYouWantToLearn: "Language you want to learn",
          chooseLanguage: "Choose language",
          priceForLesson: "Price for the lesson",
          chooseQuality:
            "Choose the quality you appreciate the most in your teacher",
        },
        showResult: "Show result",
        showMore: "Show more ({value})",
      },
    },
    modules: {
      voiceRecorder: {
        title: "Voice Recorder",
      },
      cameraInitialization: {
        title: "Camera Initialization",
      },
      cameraSettings: {
        title: "Camera Settings",
        audio: "Audio",
        video: "Video",
        microphone: "Microphone",
        camera: "Camera",
        preview: "Preview",
      },
    },
    camera: {
      cameraNotVisibleDescription:
        "If you can't see yourself, please change camera input device in settings",
      cameraSettings: "Camera Settings",
    },
    skills: {
      userCard: {
        perHour: "h.",
        review: {
          hadNLessonsTogether:
            "had no lessons together | had {value} lesson together | had {value} lessons together",
          noReviewsFound: "No reviews found for this teacher",
        },
      },
      filters: {
        lessonPrice: "Lesson price",
        studyObjectives: "Study objectives",
        form: {
          query: {
            label: "Name",
            placeholder: "Type teacher's name...",
          },
        },
      },
      noInstructorsFound: "No teachers found matching your search criteria",
    },
    search: {
      title: "Search",
      tabs: {
        all: "All",
        instructors: "Instructors",
        students: "Students",
      },
      filters: {
        interests: {
          label: "Interests",
          placeholder: "Type any interest name",
        },
        teaches: {
          label: "Teaches",
          placeholder: "Type any language name",
        },
        speaks: {
          label: "Speaks",
          placeholder: "Type any language name",
        },
        specialities: {
          label: "Specialities",
          placeholder: "Type any speciality name",
        },
        textbooks: {
          label: "Textbooks",
          placeholder: "Type any textbook name",
        },
      },
    },
    signIn: {
      title: "Sign In",
      yourEmail: "Your email",
      password: "Password",
      forgotYourPassword: "Forgot your password?",
      signUpTitle: "New to Lingua Community?",
      signUp: "Sign Up",
      submit: "Login",
    },
    signUp: {
      title: "Sign Up",
      header: "Select the type of account you'd like to create",
      signInTitle: "Have already an account?",
      signIn: "Sign In",
      student: "Student",
      instructor: "Teacher",
      form: {
        email: {
          label: "Email",
          placeholder: "Ex: example@mail.com",
        },
      },
    },
    restorePassword: {
      title: "Restore your password",
      form: {
        email: {
          label: "Email",
          placeholder: "Ex: example@mail.com",
        },
        newPassword: {
          label: "New Password",
          placeholder: "Enter your new password",
        },
      },
      submit: "Restore",
      rememberPasswordTitle: "Remember your password?",
      otpDescription:
        "Please enter 6-digit numbers below that we sent to your email",
      newPasswordDescription: "Please enter your new password",
      successDescription:
        "Your password successfully changed, please sign in with your new password",
      signIn: "Sign In",
    },
    registration: {
      registerAs: "Register as",
      student: "Student",
      teacher: "Teacher",
      signUp: "Sign Up",
      login: "Login",
      speak: "Speak:",
      teach: "Teach:",
      learn: "Learn:",
      criteria: "Criteria:",
      specialities: "Specialities:",
      textbooks: "Textbooks:",
      teachLabel: "Which language you will teach?",
      speakLabel: "Which languages do you speak-languages?",
      learnLabel: "Which language you will learn?",
      criteriaLabel: "Select criteria for teacher",
      user: {
        youRegisteredSuccessfully:
          "You were registered successfully, please follow instructions sent by email.",
        specialities: {
          learnBasics: "Learn Basics",
          talkWithPeople: "Talk With People",
          forKids: "For Kids",
          improveProficiency: "Improve Proficiency",
          doBusiness: "Do Business",
          prepareForExam: "Prepare For Exam",
        },
        studentReviewQuestions: {
          structure: {
            title: "Structure",
            shortTitle: "Structure",
            description:
              "Are the lessons connected? For instance, during the first lesson, you mastered the grammar of the modal verb «can» (I cannot help you). Next lesson - present continuous (I am watching TV). Finally, you combine both topics making sentences like “I cannot help you because I am watching TV”. Thus, structure is something more than a simple revision. Structure is when the previous grammar/vocabulary interlines with the new topic, as a result a student does not have gaps in knowledge.",
            optionsDescription:
              "1 – learnt a topic and dropped it for good. <br /> 5 – each new topic combines new grammar/vocabulary with previously learnt",
          },
          punctuality: {
            title: "Punctuality",
            shortTitle: "Punctuality",
            description:
              "In the beginning of the course, you and your teacher made an agreement regarding the schedule. You both might have agreed to meet regularly or have a floating schedule. You may also have agreed on a lesson cancelation policy. Whatever your schedule agreement is, it is important that both sides have a clear understanding and follow it.",
            optionsDescription:
              "Put 1 if you do not have a clear agreement or understanding of your teacher’s schedule policy or/and extremely unhappy with your teacher’s punctuality. <br/> Put 5 if, in general, the teacher keeps up with the schedule and does not violate the lesson cancellation policy.",
          },
          capability: {
            title: "Proven capability",
            shortTitle: "Capability",
            description:
              "How well does the teacher know the subject? We believe that, in general, a good teacher should know a little more than the books/materials he or she uses during the lesson. Otherwise, you could have found the same materials on the internet and studied them independently with the same success.",
            optionsDescription:
              "1  - I'd better study by myself <br/> 2 -  the teacher somewhat helps <br/> 3  - if the teacher has a good grasp of the material, can answer almost all the questions <br/> 4  - for sharing extra information not mentioned in the book (exceptions to the rules/different meanings of the same word) <br/> 5 – my teacher shares specific cultural aspects of behavior and language use or/and can handle some language oddities.",
          },
          skills: {
            title: "Skills developed",
            shortTitle: "Skills",
            description:
              "By the end of the lesson, have you walked away with empty hands or acquired some knowledge/skills? In other words, did you spend your time in vain or was the lesson helpful? The result could be small but measurable adding one more step closer to achieving the bigger goal.",
            optionsDescription:
              "Put 1 if you spent your time in vain and doubt that you will ever benefit from this teacher <br/> Put 5 if you certainly obtain different skills each lesson and all these skills are interconnected between each other gradually bringing you to a bigger result",
          },
          practice: {
            title: "Practice",
            shortTitle: "Practice",
            description:
              "Which language is spoken the most during the lesson: foreign or native?",
            optionsDescription:
              "1 – most of the time we speak-languages native language <br/> 5 – all the time we speak-languages only foreign language",
          },
          responsibility: {
            title: "Responsibility",
            shortTitle: "Responsibility",
            description:
              "Does the teacher take it personally when you fail or succeed?",
            optionsDescription:
              "1 – the teacher prefers not to notice my difficulties (if any): methodology is perfect, if the results are poor, the teacher hints on my sole responsibility <br/> 5 – if the results are poor, my teacher is worried, and adapts the methodology",
          },
          independence: {
            title: "Independence and thinking",
            shortTitle: "Independence",
            description:
              "How does the teacher react on your mistakes? Does he/she give you immediately the right answer or does he/she give you the chance to solve the problem independently?",
            optionsDescription:
              "1 – corrects me immediately (there is too much material, too little time) <br/> 5 – hints but never harries with the right answer, wants me to get it by myself",
          },
          allSkills: {
            title: "Does the teacher develop all 5 skills?",
            shortTitle: "All Skills",
            description:
              "Ideally, every lesson, a good teacher equally pays attention to the development of 5 language skills: listening, reading, speaking, writing, grammar.",
            optionsDescription:
              "1 - the teacher is focused only on one of these skills e.g., your teacher have been teaching only grammar <br /> 5. - a teacher has been developing all 5 skills",
          },
          timeManagement: {
            title: "Time management",
            shortTitle: "Time",
            description: "Is the lesson time used wisely or is it wasted?",
            optionsDescription:
              "1 – Considerable amount of time is spend doing things that could have been done prior to the lesson (uploading/downloading files, checking attendance, homework, searching info etc) <br /> 5 – I benefit from every single minute of the lesson",
          },
          listeningToStudent: {
            title: "Listening to student",
            shortTitle: "Student-centered",
            description:
              "Who is more active during the class: you or your teacher? Is your teacher a good listener?",
            optionsDescription:
              "1 – The teacher never gives me a chance to speak-languages <br /> 5 – Most of the time, the teacher actively listens to what I have to say",
          },
          approach: {
            title: "Approach",
            shortTitle: "Approach",
            description:
              "Some like authoritarian teachers. Others like the teachers with democratic temperament. Did your teacher find the right approach in communication with you that helps you to take the most out of the lessons?",
            optionsDescription:
              "1 – I wish the teacher could be softer/stricter to me <br /> 2 – The teacher found the best approach to me",
          },
        },
        userInterestGroup: {
          healthSport: {
            title: "Health & Sport",
          },
          goingOutEntertainment: {
            title: "Going out & Entertainment",
          },
          hobbiesEducation: {
            title: "Hobbies & Education",
          },
        },
        userInterest: {
          running: {
            title: "Running",
          },
          workout: {
            title: "Workout",
          },
          volleyball: {
            title: "Volleyball",
          },
          cycling: {
            title: "Cycling",
          },
          chess: {
            title: "Chess",
          },
          martialArts: {
            title: "Martial  Arts",
          },
          basketball: {
            title: "Basketball",
          },
          football: {
            title: "Football",
          },
          hockey: {
            title: "Hockey",
          },
          swimming: {
            title: "Swimming",
          },
          diving: {
            title: "Diving",
          },
          extremeSports: {
            title: "Extreme Sports",
          },
          formula1: {
            title: "Formula 1",
          },
          meditation: {
            title: "Meditation",
          },
          yoga: {
            title: "Yoga",
          },
          filmTv: {
            title: "Film & Tv",
          },
          theatre: {
            title: "Theatre",
          },
          eatingOut: {
            title: "Eating Out",
          },
          museums: {
            title: "Museums",
          },
          concerts: {
            title: "Concerts",
          },
          shopping: {
            title: "Shopping",
          },
          gaming: {
            title: "Gaming",
          },
          boardGames: {
            title: "Board Games",
          },
          traveling: {
            title: "Traveling",
          },
          hiking: {
            title: "Hiking",
          },
          humor: {
            title: "Humor",
          },
          business: {
            title: "Business",
          },
          finance: {
            title: "Finance",
          },
          management: {
            title: "Management",
          },
          music: {
            title: "Music",
          },
          space: {
            title: "Space",
          },
          history: {
            title: "History",
          },
          pets: {
            title: "Pets",
          },
          dancing: {
            title: "Dancing",
          },
          photography: {
            title: "Photography",
          },
          singing: {
            title: "Singing",
          },
          arts: {
            title: "Arts",
          },
          cars: {
            title: "Cars",
          },
          motorcycles: {
            title: "Motorcycles",
          },
          cooking: {
            title: "Cooking",
          },
          architecture: {
            title: "Architecture",
          },
          reading: {
            title: "Reading",
          },
          science: {
            title: "Science",
          },
          psychology: {
            title: "Psychology",
          },
          ecology: {
            title: "Ecology",
          },
          technologies: {
            title: "Technologies",
          },
          fashion: {
            title: "Fashion",
          },
          politics: {
            title: "Politics",
          },
          writing: {
            title: "Writing",
          },
          design: {
            title: "Design",
          },
          philosophy: {
            title: "Philosophy",
          },
          medicine: {
            title: "Medicine",
          },
          celebrities: {
            title: "Celebrities",
          },
          volunteering: {
            title: "Volunteering",
          },
          news: {
            title: "News",
          },
          personalGrowth: {
            title: "Personal Growth",
          },
        },
        language: {
          english: {
            title: "English",
          },
          russian: {
            title: "Russian",
          },
          kyrgyz: {
            title: "Kyrgyz",
          },
          kazakh: {
            title: "Kazakh",
          },
          uzbek: {
            title: "Uzbek",
          },
          turkmen: {
            title: "Turkmen",
          },
          armenian: {
            title: "Armenian",
          },
        },
      },
    },
    passwordRecovery: {
      title: "Password Recovery",
      enterYourEmail: "Enter your email",
      rememberYourPassword: "Remember your password?",
      submit: "Submit",
      instructionDescription:
        "Password recovery instruction was send to your email, please check your email",
      goToLoginScreen: "Go to login screen",
    },
    passwordRecoveryConfirmation: {
      title: "Password Recovery Confirmation",
      invalidResetTokenDescription:
        "Invalid reset token. Please try to recover your password again",
      goToPasswordRecoveryScreen: "Go to password recovery screen",
      enterNewPassword: "Enter new password",
      confirmYourNewPassword: "Confirm your new password",
      submit: "Change Password",
      yourPasswordSuccessfullyChanged: "Your password changed successfully",
      goToLoginScreen: "Go to login screen",
    },
    profile: {
      main: "Main",
      feed: "Feed",
      messages: "Messages",
      notifications: "Notifications",
      myConnections: "My Connections",
      activityHistory: "Activity History",
      schedule: "Schedule",
      myMaterials: "My Materials",
      savedMaterials: "Saved Materials",
      lessonsHistory: "Lessons History",
      quizzesHistory: "Quizzes History",
      detalization: "Balance Detalization",
      profileSettings: "Profile Settings",
      photo: {
        title: "Profile photo",
      },
      cover: {
        title: "Profile cover",
      },
      nConnections: "No connections | {value} connection | {value} connections",
      nStudents: "No students | {value} student | {value} students",
      nInstructors: "No teachers | {value} teacher | {value} teachers",
      connection: {
        connect: "Connect",
        invited: "Invited",
        cancelInvitation: "Cancel invitation",
        acceptInvitation: "Accept invitation",
        ignore: "Ignore",
        connected: "Connected",
        removeConnection: "Remove connection",
      },
      message: "Message",
      connections: {
        title: "Connections",
        emptyDescription: "You don't have connections yet",
      },
      about: {
        title: "About",
        teachingObjectives: "Teaching Objectives",
        learningObjectives: "Learning Objectives",
      },
      contactExchange: {
        title: "Make a trial lesson appointment",
        form: {
          telNumber: {
            placeholder: "+996 XXX YYY-YYY",
            hint: 'By sending your personal data, you agree to the <a href="/terms-of-service" target="_blank">terms of service</a>. ',
          },
        },
        exchangeContacts: "Exchange contacts",
        modal: {
          informationSentSuccessfully:
            "Your name information has been sent to the teacher",
          callYourself: "Don't want to wait? Call yourself",
          call: "Call",
        },
      },
      prices: {
        title: "Prices",
        emptyDescription: "You haven't listed your prices yet",
        form: {
          title: {
            label: "Price",
          },
        },
        addMore: "Add more",
      },
      publications: {
        shareYourExpertise: "Share Your Expertise!",
        shareYourExpertiseDescription:
          "Inspire others by creating and sharing your unique teaching materials. Click below to get started!",
        tabs: {
          posts: "Posts",
          materials: "Materials",
        },
      },
      reputation: {
        title: "Reputation",
        overallTrust: "Overall trust",
        basedOnNLessonsAndNTestimonials:
          "Based on {lessons} lessons and {testimonials} testimonials",
        whyYouCanTrustThisData: "Why you can trust this data?",
        startBuildingYourReputationDescription:
          "Teach your first lesson to begin earning reputation and showcasing your expertise",
        reputationComingSoonDescription:
          "This teacher hasn't taught enough lessons yet to establish a reputation. Stay tuned!",
      },
      reviews: {
        title: "Reviews",
        emptySelfDescription: "You don't have reviews yet",
        emptyDescription: "User doesn't have testimonials yet",
        nReviews: "No reviews | {value} review | {value} reviews",
        completedNLessons:
          "Doesn't complete any lessons | Completed {value} lesson | Completed {value} lessons",
        startCollectingTestimonialsDescription:
          "Encourage your students to leave feedback after lessons to build your credibility and attract more learners",
        noTestimonialsYet: "No Testimonials Yet",
        noTestimonialsYetDescription:
          "This teacher hasn't received any testimonials yet. Be the first to leave one after a lesson!",
        whyYouCanTrustThisData: "Why you can trust this data?",
        readPrevious: "Read previous",
        readNext: "Read next",
        seeUserAllTestimonials: "See {value}'s all testimonials",
      },
      certificates: {
        title: "Diplomas and certificates",
        form: {
          title: {
            label: "Name",
            placeholder:
              "Ex.: TOEFL iBT 83/120 [R. 22/30] [L. 28/30] [S. 30/30] [W. 24/30]",
          },
          organization: {
            label: "Issuing Organization",
            placeholder: "TOEFL Center - Bishkek",
          },
          issuedMonth: {
            label: "Issued date",
            placeholder: "Month",
          },
          issuedYear: {
            placeholder: "Year",
          },
          credentialId: {
            label: "Credential ID",
          },
          credentialUrl: {
            label: "Credential URL",
          },
          media: "Media",
        },
        emptyDescription:
          "Show off your achievements! <br /> Add your certificates to enhance your profile",
        deletionConfirmation:
          "Are you sure you want to delete this certificate?",
        item: {
          credentialId: "Credential ID",
          issued: "Issued",
          showDocument: "Show document",
          showCredential: "Show credential",
        },
      },
      instructors: {
        title: "Teachers",
        nCount: "No instructors | {value} instructor | {value} instructors",
        emptyDescription: "No teachers found",
      },
      students: {
        title: "Students",
        nCount: "No students | {value} student | {value} students",
        emptyDescription: "No students found",
      },
      edit: {
        name: {
          title: "Name",
        },
        about: {
          title: "About you",
          form: {
            longAbout: {
              placeholder: "Share about your experience, achievements, etc...",
            },
          },
        },
        profilePhoto: {
          title: "Profile photo",
          instructorDescription: `Faces build trust, not logos. Add a recognizable photo of yours to strengthen your professional brand.`,
          studentDescription: `Add a photo — your peers and teacher will love getting to know you better`,
        },
        contacts: {
          title: "Contacts",
          instructorDescription: `Everyone deserves direct, honest communication. Exchange phone numbers with your future students through a simple and convenient form.`,
          studentDescription: `If your study-mates are interested in your idea, can they contact you by phone?`,
        },
        aboutYou: {
          title: "About you",
          instructorDescription: `Describe in details your ideal student or a type of students. Why do you enjoy working with such student(s)? <br> What can you achieve together?`,
          studentDescription: `Please tell where you are from and/or what you feel strong about`,
        },
        headline: {
          title: "Headline",
          instructorDescription: `Your headline will appear on your profile and help others understand your skills and expertise at a glance`,
          studentDescription: `Describe the results you want to achieve by studying`,
        },
        teachingObjectives: {
          title: "Teaching objectives",
          description: "What did you help your ideal student(s) with?",
        },
        learningObjectives: {
          title: "Learning objectives",
          description: "For what purposes do you study languages?",
        },
        teachingLanguage: {
          title: "Teaching language",
          description: "Language you teach students",
        },
        learningLanguage: {
          title: "Learning language",
          description: "Language you are learning",
        },
        speakingLanguages: {
          title: "Learning language",
          description: "Language you are learning",
        },
        email: {
          title: "Email",
          verificationSentDescription: `We've sent a verification code to your new email address, {email}. Please check your inbox and enter the code to proceed`,
          changeEmail: "Change email",
        },
        password: {
          title: "Change password",
        },
        form: {
          common: {
            firstName: {
              label: "First name",
              placeholder: "Ivan",
            },
            lastName: {
              label: "Last name",
              placeholder: "Ivanov",
            },
            languageLevel: {
              label: "Level",
            },
            speakLanguages: {
              label: "Languages you speak",
            },
            oldPassword: {
              label: "Old password",
            },
            newPassword: {
              label: "New password",
              placeholder: "Enter your password",
            },
            password: {
              label: "Password",
              placeholder: "Enter your password",
            },
            repeatPassword: {
              label: "Repeat password",
              placeholder: "Repeat your password",
            },
            currentEmail: {
              label: "Current email",
            },
            newEmail: {
              label: "New email",
            },
          },
          instructor: {
            telNumber: {
              label: "Phone number",
              placeholder: "+996 XXX YYY-YYY",
            },
            showOnRecommendationPage: {
              label: "Help me to find students",
            },
            content: {
              placeholder:
                "My ideal student is a schoolboy preparing to enter the university of his dreams. I will help him pass IELTS.",
            },
            shortAbout: {
              label: "Headline",
              placeholder:
                "E.g., Certified English Teacher | IELTS 8.5 | CELTA Holder",
            },
            specialities: {
              label: "Teaching objectives",
              hint: "Choose not more than 3 categories",
            },
            targetLanguage: {
              label: "Teaching language",
            },
          },
          student: {
            telNumber: {
              label: "Phone number",
              placeholder: "+996 XXX YYY-YYY",
            },
            showOnRecommendationPage: {
              label: "Help me to find teacher",
            },
            content: {
              placeholder:
                "e.g. I come from a small town in Kyrgyzstan. I have been preparing for IELTS for 6 month and I am making a certain progress. I want to enter a US university under full scholarship.",
            },
            shortAbout: {
              label: "Headline",
              placeholder:
                "E.g., I dream of traveling around the US and speaking freely with people",
            },
            specialities: {
              label: "Learning objectives",
              hint: "Choose not more than 3 categories",
            },
            targetLanguage: {
              label: "Teaching language",
            },
          },
        },
      },
      quickProfileUpdate: {
        title: "Update your profile",
        updateSuccess:
          "We set this information to your profile. See if you like it. If not, feel free to change it.",
        letsStart: "Lets start",
        instructor: {
          description:
            "Answer a few questions to set up your profile and get your ideal student match",
        },
        student: {
          description: "Why study alone? Let us introduce you to community.",
        },
      },
    },
    notifications: {
      notificationsManagement: "Notifications management",
      tabs: {
        all: {
          short: "All",
          long: "All notifications",
        },
        lesson: {
          short: "Lesson",
          long: "Lesson notifications",
        },
        other: {
          short: "Other",
          long: "Other notifications",
        },
      },
    },
    lessons: {
      lessonsManagement: "Lessons management",
      upcomingLessons: "Upcoming lessons",
      pastLessons: "Past lessons",
      newLesson: "New Lesson",
      startInstantLesson: "Start instant lesson",
      scheduleLesson: "Schedule a lesson",
      currentLessons: "Current lessons",
      emptyStartingLessonsInstructor:
        "You don't have any lessons starting soon. But you have lessons scheduled for later! <br> You can also start an instant lesson or schedule a new one below",
      emptyStartingLessonsStudent:
        "You don't have any lessons starting soon. Check your schedule below for upcoming lessons, or contact your teacher for more details",
      scheduledItem: {
        noParticipants: "No participants",
        andNParticipants:
          "no participant | and {value} participant | and {value} participants",
        live: "live",
        details: "Details",
        lessonWasCancelled: "Lesson was cancelled",
        reason: "Reason",
        preview: "Preview",
        joinNow: "Join now",
        reschedule: "Reschedule",
        cancel: "Cancel",
        teacher: "Teacher",
        students: "Student(s)",
        userXLeftLessonAt: "{userFullName} left the lesson at {time}",
        userXCancelledLessonAt: "{userFullName} cancelled the lesson at {time}",
      },
      schedule: {
        title: "Schedule a lesson",
        editParticipants: "Edit participants",
        additionalSettings: "Additional settings",
        participants: "Participants",
        emptyParticipants:
          "No participants have been added yet. To add participants, please click the button below",
        addParticipants: "Add participants",
        form: {
          title: {
            label: "Title",
          },
          startsAt: {
            label: "Lesson starting from",
          },
          duration: {
            label: "Duration",
            items: {
              "30min": "30 min.",
              "45min": "45 min.",
              "1hour": "1 hour",
              "1halfHours": "1.5 hours",
              "2hours": "2 hours",
            },
          },
          lessons: {
            label: "Lessons",
            placeholder: "Start typing to search lessons",
            rules: {
              required: "You must select at least one lesson",
            },
          },
          quizzes: {
            label: "Quiz",
            placeholder: "Start typing to search quizzes",
            rules: {
              required: "You must select at least one quiz",
            },
          },
          students: {
            label: "Students",
            placeholder: "Start typing to search from your connections",
            rules: {
              required: "You must select at least one student",
            },
          },
          price: {
            label: "Price",
            rules: {
              required: "You must set positive number",
            },
          },
          commonPrice: {
            label: "Common price",
          },
          notes: {
            label: "Notes",
          },
        },
      },
      cancelSchedule: {
        title: "Cancelling a scheduled lesson",
        form: {
          reason: {
            label: "Reason",
            placeholder:
              "Please provide a brief explanation for your lesson cancellation (e.g., scheduling conflict, personal emergency)",
          },
        },
      },
      selectUsers: {
        title: "Select user(s) to add into lesson",
      },
    },
    main: {
      endOfActivities: "End of activities",
      noActivities: "No activities",
      previewAlert: {
        title: "Looking for your profile preview?",
        description: "You can find your profile view by clicking button below",
        button: "My profile preview",
      },
    },
    myConnections: {
      networkManagement: "Network management",
      invitations: "Invitations",
      myInvitations: "My invitations",
      myConnections: "My connections",
      userConnections: "User connections",
      noConnectionsYet: "You don't have connections yet",
      noConnectionFoundForYourRequest: "No connection found for your request",
      pendingSharedContacts: "Pending shared contacts",
      noPendingSharedContacts: "No Pending shared contacts",
      markAsRead: "Mark as read",
      manageSharedContacts: "Manage shared contacts",
      pendingInvitations: "Pending invitations",
      manageInvitations: "Manage invitations",
      manageMyConnections: "Manage my connections",
      noPendingInvitations: "No pending invitations",
    },
    preferences: {
      title: "Settings",
      account: {
        title: "Account preferences",
        groups: {
          profileInformation: {
            title: "Profile Information",
            items: {
              name: "Name",
              contact: "Contacts",
              headline: "Headline",
              about: "About",
              teachingObjectives: "Teaching Objectives",
              learningObjectives: "Learning Objectives",
              teachingLanguage: "Teaching language",
              learningLanguage: "Learning language",
              speakingLanguages: "Speaking languages",
            },
          },
        },
      },
      signInAndSecurity: {
        title: "Sign in & security",
        groups: {
          security: {
            title: "Security",
            items: {
              email: "Email",
              password: "Change password",
            },
          },
        },
      },
      logout: {
        title: "Logout",
      },
    },
    userConnections: {
      title: "User connections",
    },
    logout: {
      loggingOut: "Logging out...",
    },
    detalization: {
      title: "Balance Detalization",
      dateRange: "Date range",
      type: "Type",
      createdAt: "Created at",
      in: "In",
      out: "Out",
      balanceBefore: "Balance before",
      balanceAfter: "Balance after",
      sum: "Sum",
      noHistoryFound: "No transactions found",
    },
    activityHistory: {
      title: "Activity History",
      groupedItemTitle: {
        today: "Today",
        yesterday: "Yesterday",
        thisWeek: "This week",
        thisMonth: "This Month",
        thisYear: "This year",
        earlier: "Earlier",
      },
      createdLesson: "Created lesson",
      scheduledLesson: "Scheduled lesson by",
      startedLesson: "Started lesson by",
      with: "with",
      createdQuiz: "Created quiz",
      finishedQuiz: "Finished quiz",
      and: "and",
    },
    materials: {
      materials: "Materials",
      tabs: {
        lessons: "Lessons",
        quizzes: "Quizzes",
        fileManager: "File Manager",
      },
      savedMaterials: "Saved Materials",
      author: "Author",
      whiteboard: "Whiteboard",
      myMaterials: "My Materials",
      title: "Title",
      createdAt: "Created at",
      actions: "Actions",
      details: "Details",
      creating: "Creating",
      updating: "Updating",
      choose: "Choose",
      attachmentDeletionConfirmation:
        "Are you sure you want to delete this attachment?",
      audioDeletionConfirmation: "Are you sure you want to delete this audio?",
      description: "Description",
      notes: "Notes",
      mainInfo: "Main Info",
      audio: "Audio",
      attachments: "Attachments",
      vocabulary: "Vocabulary",
      asVocabulary: "Use just as vocabulary",
      itemsPerPage: "Exercises per page",
      points: "Points",
      user: "User",
      nonRegisteredUser: "Non Registered User",
      nonRegisteredUserTelNumber: "Non Registered User Tel.",
      backToMain: "Back to main",
      backToLessons: "Back to lessons",
      lesson: {
        title: "Lesson",
        tabs: {
          main: {
            title: "Main",
          },
          attachments: {
            title: "Attachments",
            tabs: {
              audio: "Audio",
              documents: "Documents",
              "board-documents": "Board Documents",
            },
          },
          exercises: {
            title: "Exercises",
            tabs: {
              vocabulary: "Vocabulary",
              exercises: "Exercises",
            },
          },
          whiteboard: {
            title: "Board",
          },
        },
        form: {
          title: {
            label: "Title",
          },
          category: {
            label: "Category",
          },
        },
        sharingSettings: {
          title: "Sharing Settings",
        },
      },
      lessons: {
        all: "All",
        owned: "Owned",
        forked: "Saved",
        lessonsList: "Lessons list",
        lessons: "Lessons",
        duration: "Duration",
        myLessons: "My lessons",
        newLesson: "New Lesson",
        deletionConfirmation: "Are you sure you want to delete this lesson?",
        filters: "Filters",
        authorizeToAccessBoard:
          "Board is not available for unregistered users, to access board please sign in",
        noLessonsFound: "No lessons found",
        noDescriptionAddedYet: "No lesson description added yet",
        addDescription: "Add description",
        editDescription: "Edit description",
      },
      quiz: {
        title: "Quiz",
        exercisesPerPageHint: "0 means all exercises will be in one page",
        tabs: {
          edit: {
            title: "Edit",
          },
          main: {
            title: "Main",
          },
          history: {
            title: "History",
          },
        },
        types: {
          exercise: {
            title: "Exercise",
          },
          vocabulary: {
            title: "Vocabulary",
          },
        },
        form: {
          title: {
            label: "Title",
          },
          category: {
            label: "Category",
          },
        },
        sharingSettings: {
          title: "Sharing Settings",
        },
        additionalSettings: {
          title: "Additional Settings",
        },
      },
      quizzes: {
        all: "All",
        owned: "Owned",
        forked: "Saved",
        quizzesList: "Quizzes list",
        details: "Details",
        backToQuiz: "Back to quiz",
        backToHistory: "Back to history",
        numberOfExercises: "Number of exercises",
        maxPoints: "Max points",
        quizzes: "Quizzes",
        myQuizzes: "My quizzes",
        history: "History",
        linkedQuizzes: "Linked quizzes",
        linkedVocabulary: "Linked vocabulary",
        newQuiz: "New Quiz",
        linking: "Linking",
        quiz: "quiz",
        quizUF: "Quiz",
        vocabulary: "vocabulary",
        deletionConfirmation: "Are you sure you want to delete this quiz?",
        unlinkConfirmation: "Are you sure you want to unlink this quiz?",
        navigation: "NAVIGATION",
        filters: "Filters",
        student: "Student",
        setFlag: "Set flag",
        unsetFlag: "Unset flag",
        submitConfirmation: "Are you sure you want to submit this quiz?",
        noAnswerExercises: "You have uncompleted exercises",
        weAreSorryQuizNotFound: "We are sorry, quiz not found :(",
        nonRegistered: {
          title: "Please provide your information",
          fullName: "Full name",
          telNumber: "Tel. number",
        },
        allUsers: "All Users",
        registeredUsers: "Registered Users",
        nonRegisteredUsers: "Non Registered Users",
        self: "Self",
        noDescriptionAddedYet: "No quiz description added yet",
        addDescription: "Add description",
        editDescription: "Edit description",
        editAdditionalSettings: "Edit additional settings",
        authorizeToAccessHistory:
          "No history available, to save your results please sign in",
        noQuizzesFound: "No quizzes found",
        noQuizHistoriesFound: "No quiz histories found",
      },
      exercises: {
        exercises: "Exercises",
        exercise: "Exercise",
        noAnyExercises: "No any exercises",
        noAnyVocabulary: "No any vocabulary",
        noAnswer: "No answer",
        detailsAreNotAvailable:
          "Details are not available, cause author of this exercise changed it after you submitted current quiz.",
        types: {
          dragTheWords: {
            title: "Drag the Words",
            adminDescription: "Drag the words admin description",
            studentDescription: "Drag the words student description",
            draggable: "Draggable",
            markSelected: "Mark selected as draggable",
            unmarkSelected: "Unmark selected",
          },
          dragTheWordsImage: {
            title: "Drag the Words Image",
            adminDescription: "Drag the words admin description",
            studentDescription: "Drag the words student description",
            draggable: "Draggable",
            markSelected: "Mark selected as draggable",
            unmarkSelected: "Unmark selected",
          },
          fillInTheBlanks: {
            title: "Fill in the Blanks",
            adminDescription: "Fill in the blanks admin description",
            studentDescription: "Fill in the blanks student description",
            or: "Or",
            anyChar: "Any character",
            anyText: "Any text",
            addAnotherOption: "Add another option",
            markSelected: "Mark selected as field",
            unmarkSelected: "Unmark selected",
            field: "Field",
          },
          fillInTheBlanksImage: {
            title: "Fill in the Blanks Image",
            adminDescription: "Fill in the blanks admin description",
            studentDescription: "Fill in the blanks student description",
            or: "Or",
            anyChar: "Any character",
            anyText: "Any text",
            addAnotherOption: "Add another option",
            markSelected: "Mark selected as field",
            unmarkSelected: "Unmark selected",
            field: "Field",
          },
          findSynonym: {
            title: "Find Synonym",
            adminDescription: "Find synonym admin description",
            studentDescription: "Find synonym student description",
            markMainSynonymSelected: "Mark selected as main synonym",
            markRealSynonymSelected: "Mark selected as real synonym for main",
            markFakeSynonymSelected: "Mark selected as fake synonym for main",
            unmarkSelected: "Unmark selected",
            synonym: "Synonym",
            real: "Real",
            fake: "Fake",
          },
          findThePlace: {
            title: "Find the Place",
            adminDescription: "Find the place admin description",
            studentDescription: "Find the place student description",
            real: "Real",
            fake: "Fake",
            insertFakePlace: "Insert fake place",
            markRealPlaceSelected: "Mark selected as real place",
            unmarkSelected: "Unmark selected",
          },
          markTheWords: {
            title: "Mark the Words",
            adminDescription: "Mark the words admin description",
            studentDescription: "Mark the words student description",
            correct: "Correct",
            wrong: "Wrong",
            markCorrectSelected: "Mark selected as correct answer",
            markWrongSelected: "Mark selected as wrong answer",
            unmarkSelected: "Unmark selected",
          },
          multipleChoice: {
            title: "Multiple Choice",
            adminDescription: "Multiple choice admin description",
            studentDescription: "Multiple choice student description",
          },
          singleChoice: {
            title: "Single Choice",
            adminDescription: "Single choice admin description",
            studentDescription: "Single choice student description",
          },
          trueFalse: {
            title: "True or False",
            adminDescription: "True or false admin description",
            studentDescription: "True or false student description",
          },
        },
        true: "True",
        false: "False",
        answer: "Answer",
        title: "Title",
        type: "Type",
        description: "Description",
        text: "Text",
        chooseImage: "Choose image",
        descriptionAudio: "Audio description",
        answerAudio: "Audio answer",
        attachedAudio: "Audio attached",
        audioHint:
          "Below checked options will work if quiz's exercises per page is 1",
        hideAudio: "Hide audio",
        audioAutoplay: "Autoplay",
        answerOptions: "Answer options",
        selectCorrectAnswers: "Select correct answers",
        selectCorrectAnswer: "Select correct answer",
        errorHint: "Error hint",
        addOption: "Add option",
        deletionConfirmation: "Are you sure you want to delete this exercise?",
        total: "Total",
        nExercises: "{count} exercise | {count} exercises",
        nVocabularies: "{count} vocabulary | {count} vocabularies",
        nPoints: "{count} point | {count} points",
        addExercise: "Add Exercise",
        selectExerciseType: "Select exercise type",
        newVocabulary: "New Vocabulary",
        linkExercisesFromQuiz: "Link exercises from quiz",
        linkVocabulary: "Link vocabulary",
        searchLabel: "Search: title, type",
        points: "Points",
        createdAt: "created at {createdAt}",
        goBack: "Go back",
        creating: "Creating",
        editing: "Editing",
        showCorrectnessOnError: "Show correctness after check",
        countPartialPts: "Count partial points",
        nOfxPts: "<b>{count}</b> out of <b>{points}</b> points",
        upload: "Upload",
        record: "Record",
        audioNotSelectedOrRecorded: "Audio is not selected or recorded",
        preview: "Preview",
      },
      privacy: {
        privacy: "Privacy",
        public: "Public",
        publicDescription: "Everyone can see this material",
        hidden: "Hidden",
        hiddenDescription: "Only author can see this material",
        scheduled: "Scheduled",
        scheduledDescription: `This material can be available from scheduled date up to 3 days`,
        forConnections: "For connections",
        forConnectionsDescription: `Only author's connections can see this material`,
      },
      publication: {
        form: {
          title: {
            placeholder: "Title",
          },
          level: {
            label: "Level",
          },
          description: {
            placeholder: "Description",
          },
        },
        selectFromMyOwnMaterials: "Select from my own materials",
        publicationIsEmpty: "Publication is empty",
        selectUsersToSend: "Select user(s) to send publication",
        repostDescription: {
          repost: "Instantly bring publication to other's feed",
          repostWithYourThoughts: "Create new post with current publication",
        },
        copyLinkToPublication: "Copy link to publication",
        section: {
          generatedTitle: "Section #{value}",
          deletionConfirmation: "Are you sure you want to delete this section?",
          addSection: "Add section",
          sectionIsEmpty: "So far the section is empty",
          addResource: "Add resource",
          selectResourceType: "Select resource type",
          resource: {
            form: {
              content: {
                placeholder: "Write resource content...",
              },
            },
            deletionConfirmation:
              "Are you sure you want to delete this resource?",
            copyLinkToResource: "Copy link to resource",
            selectUsersToSend: "Select user(s) to send resource",
            groups: {
              interactivity: {
                title: "Interactivity",
              },
              mediaAssets: {
                title: "Media Assets",
                items: {
                  media: "Image / Video",
                  audio: "Audio",
                  text: "Text",
                },
              },
            },
            repostDescription: {
              repost: "Instantly bring resource to other's feed",
              repostWithYourThoughts: "Create new post with current resource",
            },
          },
        },
        searchForAnyMaterial: "Search for any material(s)",
        own: "Own",
        common: "Common",
        noPublicationsFound: "No publications found",
        noSavedPublicationsFound: "No saved publications found",
        createPublication: "Create publication",
        commonPublications: "Common publications",
        myPublications: "My publications",
        savedPublications: "Saved publications",
        allMyPublications: "All my publications",
        allSavedPublications: "All saved publications",
      },
    },
    messages: {
      title: "Messages",
      selectContacts: {
        title: "Select user to start chatting",
      },
      chat: {
        title: "Chat",
        search: "Search...",
        writeMessage: "Write a message...",
        typeToMessage: "Type to message",
        endMessage: "This is end of messages",
        youDontHaveAnyChat: "You haven't chatted yet",
        startChattingDescription:
          "Start chatting by selecting one of your connections",
        startChatting: "Start chatting",
        send: "Send",
        connections: {
          title: "Connections",
        },
      },
    },
    lessonBoards: {
      myLessonBoards: "My lesson boards",
      createLessonBoard: "Create a board",
      noLessonBoardsFound: "No boards found",
    },
    profileSettings: {
      title: "Profile settings",
      editingProfile: "Editing profile",
      basicInfo: "Basic info",
      aboutProfile: "About profile",
      balanceDetalization: "Balance detalization",
      backToProfileSettings: "Back to profile settings",
      interests: "Interests & Hobbies",
      textbooks: "Textbooks",
      prices: "Prices",
      additionalInfo: "Additional info",
      mainInfo: "Main info",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phoneNumber: "Phone number",
      profilePhoto: "Change photo",
      buttonContinue: "Continue",
      showOnRecommendationPage: "Show on recommendation page",
      shortAbout: "Short about yourself",
      longAbout: "About yourself",
      shortAboutHint: "Describe yourself shortly",
      longAboutHint: "Describe yourself",
      buttonSave: "Save",
      buttonPrevious: "Previous",
      pricesTab: {
        title: "Title",
        addMore: "Add more",
        emptyDescription: "You haven’t listed your prices yet",
      },
    },
    userProfile: {
      about: "About",
      wasOnline: "Was online:",
      teaches: "Teaches:",
      speaks: "Speaks:",
      specialities: "Specialities:",
      textbooks: "Textbooks:",
      interests: "Interests:",
      learns: "Learns:",
      prices: "Prices",
      priceTable: {
        title: "Title",
        price: "Price (per hour)",
      },
      mustRate: "You must rate by every criterion",
      leaveThoughts: "Leave your thoughts about your instructor",
      reviewComponentTitle:
        "Please rate work of the teacher, according your criteria",
      reviews: "Reviews",
      edit: {
        userAbout: {
          form: {
            longAbout: {
              placeholder: "Share about your experience, achievements, etc...",
            },
          },
        },
        certificate: {
          form: {
            title: {
              label: "Name",
              placeholder:
                "Ex.: TOEFL iBT 83/120 [R. 22/30] [L. 28/30] [S. 30/30] [W. 24/30]",
            },
            organization: {
              label: "Issuing Organization",
              placeholder: "TOEFL Center - Bishkek",
            },
            issuedMonth: {
              label: "Issued date",
              placeholder: "Month",
            },
            issuedYear: {
              placeholder: "Year",
            },
            credentialId: {
              label: "Credential ID",
            },
            credentialUrl: {
              label: "Credential URL",
            },
            media: "Media",
          },
        },
      },
    },
    schedule: {
      title: "Schedule",
      plannedLesson: "Planned lesson",
      start: "Start",
      lessonWith: "Lesson with {instructorFirstName} {instructorLastName}",
      deleteConfirmation: "Are you sure to delete lesson schedule plan?",
      today: "Today",
      day: "Day",
      week: "Week",
      month: "Month",
      "4days": "4 days",
      createLessonSchedule: "Planing new lesson",
      updateLessonSchedule: "Updating existing schedule",
      startNow: "Start now",
      schedule: "Schedule",
      calendarCard: {
        title: "Title",
        plannedDate: "Planned date",
        lessons: "Lessons",
        students: "Students",
        notes: "Notes",
      },
      history: "History",
    },
    liveLesson: {
      tabs: {
        main: {
          title: "Main",
        },
        attachments: {
          title: "Attachments",
          tabs: {
            audio: "Audio",
            documents: "Documents",
            "board-documents": "Board Documents",
          },
        },
        exercises: {
          title: "Exercises",
          tabs: {
            vocabulary: "Vocabulary",
            exercises: "Exercises",
          },
        },
        whiteboard: {
          title: "Board",
        },
        chat: {
          title: "Chat",
        },
        live: {
          title: "Live",
        },
        material: {
          title: "Material",
        },
      },
      lesson: "Lesson",
      currentLiveScheduledLessons: "Current live lessons",
      upcomingScheduledLessons: "Upcoming scheduled lessons",
      noUpcomingSchedules: {
        title: "No Upcoming Events",
        description: "You don't have any upcoming lessons planned",
      },
      attachments: {
        editAttachments: "Edit attachments",
        lessonAttachments: "Lesson attachments",
        boardAttachments: "Board Attachments",
        noLessonAttachmentsAddedYet: "No lesson attachments added yet",
        noLessonAudiosAddedYet: "No lesson audio added yet",
        noBoardAttachmentsAddedYet: "No board attachments added yet",
      },
      live: {
        title: "Live",
        join: "Join",
        videoIsNotAvailable: "Video is not available",
        you: "You",
        lessonIsOver: "Lesson is already over",
        lessonNotStarted: "Lesson is not started yet",
        readyToJoin: "Ready to join?",
        youHaveNotJoinedYet:
          "You haven't joined to live yet, would you like to join?",
        lessonScheduledInfo:
          "Live lesson scheduled at <b>{lessonStartsAt} - {lessonEndsAt}</b>",
        tooEarlyToJoin:
          "Your lesson starts at {lessonStartsTime} on {lessonStartsDate}. <br /> Your local time is {localTime} {localDate}.",
        tooLateToJoin:
          "Your lesson started at {lessonStartsTime} and ended at {lessonEndsTime} on {lessonEndsDate}. <br /> Your local time is {localTime} {localDate}.",
      },
      board: {
        noBoardsCreatedYetInstructor:
          "No any lesson-boards were created, would you like to create?",
        noBoardsCreatedYetStudent:
          "No any lesson-boards were created, ask your instructor to create one",
        add: {
          title: "Adding new board",
          boardName: {
            label: "Board name",
            placeholder: "Enter board name",
          },
          cloneFrom: {
            title: "Clone from",
            lessonBoards: "Lesson lesson boards",
            latestBoards: "Latest lesson boards",
            boardsWithCurrentStudents: "Boards with current students:",
          },
        },
        lock: "Lock",
        sync: "Sync between users",
        additionalOptions: "Additional options",
        borderStyleOpacityAndColor: "Border style, opacity and color",
        colorAndOpacity: "Color and opacity",
        color: "Color",
        bringToFront: "Bring to front",
        bringForward: "Bring forward",
        sendToBack: "Send to back",
        sendBackward: "Send backward",
        image: "Image",
        video: "Video",
        audio: "Audio",
        document: "Document",
        fromYourDevice: "From your device",
        pasteDirectUrl: "Paste direct url",
        yourVideoUrl: "Your video url",
        pasteViaYouTubeUrl: "Paste via YouTube url",
        youTubeVideoUrl: "YouTube video url",
      },
      audio: {
        addAudio: "Add audio",
        editAudio: "Edit audio",
      },
      attachment: {
        add: "Add attachments",
        edit: "Edit attachments",
      },
      exercise: {
        addExercises: "Add exercises",
        editExercises: "Edit exercises",
        noLessonExercisesAttachedYet: "No lesson exercises attached yet",
      },
      vocabulary: {
        addVocabulary: "Add vocabulary",
        editVocabulary: "Edit vocabulary",
        noLessonVocabularyAttachedYet: "No lesson vocabulary attached yet",
      },
      chat: {
        typeSomething: "Type something...",
      },
      noAnyLessonAddedYet: "No any lesson added yet",
      addLesson: "Add a lesson",
      authRequired: "Authentication Required",
      authRequiredDescription:
        "Please sign in or create an account to join the live lesson",
    },
    accessDenied: {
      title: "Access denied, not enough privileges",
    },
    pageNotFound: {
      title: "Page not found",
    },
    externalLink: {
      description: "You are about redirecting link...",
    },
    landing: {
      // Header
      greeting: "Hello",
      howItWorks: "How it works?",
      findTeacher: "Find a teacher",
      advantages: "Advantages",
      prices: "Prices",
      // Hero
      socialPlatform: "Social platform for teaching and studying languages",
      hereSuccess:
        "Here, successful students recommend their professional teachers. ",
      register: "Sign up / Sign in",
      findATeacher: "Find a teacher",
      magicStarts:
        "The true magic starts when we admit those who stand behind our success.",
      heroAddress: "Akilay Ms. Kyrgyzstan 2023 ",
      // GALLERY
      dontRisk: "Don't risk, don't trust commercial. Trust people. Ask people.",
      weOffer:
        "We offer simple easy-to-use tools to assess teachers' professional qualities. ",
      supportedByLocal: "Supported by local influencers",
      criteria: "6 criteria ",
      assessTeachers: "To assess teachers' professional qualities",
      freeForStudents: "The platform is free for students",
      realTestimonials:
        "Real testimonials and recommendations from real people",
      //   whyChoose
      weHelp: "We help",
      students: "Students",
      toFindIdealTeacher:
        "To find the ideal teacher based on our community's independent assessment and testimonials. ",
      teachers: "Teachers",
      toDevelop:
        "To develop a personal brand of a professional teacher supported by our community's independent assessment and testimonials.",
      //   howItIsWork
      seeHowItWork: "See how it works",
      choosingATeacher: "Choosing a teacher",
      lessonRoutine: "Assessment of the teacher's proffesional qualities.",
      independentAssessment: "Independent assessment at work",
      //   Testimonials
      communityIndependent: "Community's independent assessment in details",
      howToChoose: "How to choose a teacher",
      findYourIdealTeacher:
        "Find your ideal teacher based on professional qualities ratings: punctuality, proven capability, skills developed etc. \n",
      findYourIdealTeacher2:
        "You can also search by specialization (Business language, IT, academic language, etc.)" +
        '    "Contact your teacher and discuss the details',
      ourQualityControl: "Our quality control",
      theLessonsAreConducted:
        "The lessons are conducted inside our platform to make sure we receive real testimonials from real students.",
      inAddition:
        "In addition, the platform is convenient. Everything a teacher or a student may need is inside the platform: materials, lesson plans, tools, interactive exercises, video-calls, online whiteboard etc. ",
      testimonialsAfterLesson: "Testimonials after a lesson",
      byTheEndOf:
        "By the end of the lesson, a pop-up message appears asking to write a testimonial. The more lessons a student had, the more his or her assessment influences the teacher's rating. ",
      //   ProfileSection
      exampleProfile: "Example of a teacher's profile.",
      aboutMe: "About me",
      myStudentsReach:
        "My students reach their goals. My ratings confirm I earned a reputation of a competent and a strict teacher.",
      education: "Education",
      americanUniversity: "American University in Central Asia",
      certificates: "Certificates",
      testimonials: "Testimonials",
      readMore: "Read more",
      provenCapability: "Proven capability",
      strictness: "Strictness",
      punctuality: "Punctuality",
      overallLessons: "Overall lessons",
      skillsDeveloped: "Skills developed",
      lessonPrice: "per lesson",
      yourPhone: "Your phone",
      yourContact: "Your name information has been sent to the teacher",
      yourContact2: "Don't want to wait? Call yourself.",
      bySending:
        "By sending your personal data, you agree to the terms and conditions. ",
      exchangeContacts: "Exchange the contacts",
      call: "Call",
      completedLesson: "10 lessons completed",
      studentRating: `Aigul was my tutor for a year and a half. We had both face-to-face and online classes, and both options completely satisfied. The atmosphere during busy times was friendly, I felt an individual approach.`,
      //   chooseTeacher
      howToFind: "How to find your ideal teacher",
      clearAssessment: "Clear assessment criteria",
      whatIsPunctuality: "How to find the most punctual teachers?",
      howToFindACompetentTeacher: "How to find a competent teacher",
      howToFindAResultOrientedTeacher:
        "How to find a teacher who gives results",
      howToFindThePerfectTeacher: "How to find the ideal teacher",
      demanding: "Demanding high standards",
      howLesson: "How is the lesson going?",
      aboutUs: "About Us",
      //     teachers In Platform
      ourTeachers: "Our teachers",
      aigul: "Aigul",
      experience: "Certified teacher with 5 year experience",
      readMoreBtn: "Read more",
      chooseATeacher: "Choose a teacher",
      becomeATeacher: "Become a teacher",
      //     level
      whatIsYourLevel: "What is your language proficiency level?",
      doTheTest:
        "Do the test and we send you video with error analysis, individual study plan, and choose the ideal teacher for you. ",
      tryItNow: "Try it now",
      //   help learners
      weHelpLearners: `We help learners and educators to find each other and develop a meaningful relationship based on effective learning `,
      //   Guaranteed
      guaranteedBenefits: "Guaranteed benefits for students and teachers",
      toTheStudents: "To the students",
      realRating: `Real testimonials from real people instead of another beautiful commercial with empty promises`,
      riskFree:
        "Risk-free strategy to find your ideal teacher based on experience of previous users",
      studyMotivated: "Study with most motivated teachers",
      workWithout:
        "Work without intermediaries, pay only for your teacher's professionalism, avoid unnecessary expenses including third party salary",
      noWaitList:
        "No waiting lists. Directly name your teacher to arrange details quickly and effectively. ",
      easyLearn:
        "Easily learn foreign language with the help of professional teachers. ",
      //   teacher
      toTheTeacher: "To the teachers",
      anOpportunity:
        "An opportunity to develop your professional brand supported by our community's independent assessment and testimonials.",
      avoidEmotional:
        "Avoid emotional burnout. You will receive regular feedback from your students, including words of gratitude and suggestions for further development of your professional qualities.",
      theOpportunityToTeach:
        "The opportunity to teach, independently determining the price, taking the entire receipt for yourself",
      increaseCost: `Increase the cost of an hour of classes by actually proving your competencies`,
      increaseYourIncome:
        "Increase your income by switching from individual to group lessons",
      workWithoutInter:
        "Work without intermediaries, organize work in a way that is convenient for the student and you",
      // convenient-platform
      convenientTitle:
        "One convenient platform instead of ten over-head apps. ",
      allYouNeed: "All you need in one place",
      doUVideoCall:
        "Do you video call on zoom? Do you read books in another window? Do you use interactive whiteboard? On our platform you will find it all in a single window",
      trackProgress: "Track progress ",
      inStudents: "In students' profile, you can see homework performance",
      stableVideoCall: "Stable video calls",
      hdQuality:
        "HD quality video calls with minimum time latency even if internet traffic is low.",
      affordablePrice: "Affordable prices",
      weTake:
        "We take a symbolic monthly payment from the teachers, which doesn't influence on the lesson fees.",
      // view possibilities
      seeWhatInside: "See what inside the platfrom",
      tryItYourself: "Try it yourself",
      audio: " Audio",
      test: "Tests",
      dictionary: "Dictionary",
      board: " Board for work",
      //   Plans
      planPrices: "Prices",
      forThePlatform: "$ for the platform itself",
      useItForFree: "Use it for free",
      tryIt: "Try it",
      currency: "$10",
      monthly: "USD monthly",
      firstMonth: "First month for free",
      //    creator
      aboutFounder: "About our founder",
      goToProfile: "Go to profile",
      ceoName: "Ruslan Leontev",
      ceoExperience:
        "An academic English tutor with 11-year experience in teaching. ",
      ceoUniversity: "A graduate of American University in Central Asia",
      ceo1Text: `I speak English because I come from a small town. It is in the big cities that the neon lights from billboards captivate one's imagination. Advertisement and commercial rule the world. They make us hallucinate about superpower of education and self-development. Of course, they sell courses.`,
      ceo2Text: `None of it is like that in my town. We don't even have any English courses, and the Internet is too slow. Therefore, we have not heard of any advertising of educational services. "If you want to study English, go to Galina Dzhoraevna", that's what people say in my hometown referring to the locally-known private teacher. Here people live in a close community, exchange news, recommend specialists to each other, and one's good reputation is the only marketing strategy. In 2007, after returning from the army, I decided I want to get education. Of course, I turned to Galina for help. Taking lessons at Galina's place, I discovered a whole new world in which young people, the Galina's students, fluently spoke English. However, they didn't stop on that ...`,
      ceo3Text: `Galina's students strived for excellence, a super result: the highest score on international exams (TOЕFL, IELTS, SAT). They dreamt big: entering a prestigious university abroad, studying under full-ride scholarship. Alisher got into the University of Washington. Spartak went to American University in Bulgaria. In four years, at the commencement ceremony in American University of Central Asia, among graduates, there were six students of Galina including myself. Back in 2007, when I knocked the door of my English teacher's house for the first time, education abroad wasn't a popular advertisement slogan, and many of my progressive friends from the capital city wouldn't believe it was possible. Yet, we, the students of Galina, achieved high results in learning foreign languages.`,
      ceo4Text: `People live differently in big cities. Everybody is in a hurry. They rarely talk to each other, rarely have a chance to recommend each other truly professional teachers. If they happen to share their success stories, they do it in a wrong way. Driven by a myth of self-made man, they fail to reveal the names of those who guided them to success. Thus, the names of professional teachers remains unknown.  The advertisement fills in the gap. Thus, the advertisment becomes more important than teachers' reputation.`,
      ceo5Text: `I offer a simple strategy in the choice of education provider. Don't believe the advertising. Trust only independent assesment and testimonials. Lingua.community offers independent assessment of English teachers based on their ratings and honest reviews.  `,
      ceo6Text: `The project is devoted to the memory of Mrs Akhmedova Galina Dzhoraevna, a truly dedicated teacher.`,
      hidden: "Hidden",
      seeMore: "Read more",
      //    form component
      startTeaching: "Start teaching or learning languages today.",
      byRegister: `By registering on the Lingua.community website, you become part of a new culture. We are a community of successful and self-sufficient students who say thank you to truly professional teachers and recommend them to other people. If you need help or advice, we will be happy to be with you`,
      connectAndJoin: "Connect and join",
      talkToUs: "Talk to us in telegram",
      // footer
      companyName: "Leontev and Partners Ltd.",
      terms: "Terms of Service",
      personalInfo: "Privacy Policy ",
      europe: "Funded by Accelerate Prosperity",
      socialNetworks: "We are in social networks",
      techSupport: "Technical support in live chat",
      //   rating
      firstRatingName: "Akylai Kalberdieva",
      firstRatingDescription:
        "I have been studying English with you for three months, and I have increased language proficiency from the pre-intermediate to advanced level.",
      firstRatingLessons: "42 lessons passed.",
      secondRatingName: "Jamilya Dunganova",
      secondRatingDescription: `I have been studying English with you for three months, and I have increased language proficiency from the pre-intermediate to advanced level.`,
      secondRatingLessons: "158 lessons passed. ",
      thirdRatingName: "Salizhan Zhumaliev",
      thirdRatingDescription: `I am 17 years old. I recently passed IELTS with the overall band of 7.5 points. I am thankful to my English teacher, Leontev Ruslan. I recommend him to everyone. `,
      thirdRatingLessons: "216 lessons passed",
      fourRatingName: "Adel Asanalieva",
      fourRatingDescription: `I entered Anglia Ruskin University in Cambridge. I majored in biomedicine. I wanted to express my gratitude to my academic English tutor, Ruslan Leontiev, who helped me prepare for international exams and get high scores, enter a prestigious university, last but not least, I am thankful to Rulsan for my personal growth and development of academic skills `,
      fourRatingLessons: "314 lessons passed. ",
    },
    termsOfService: {
      content:
        '<div class="mx-2 my-4"><div class="text-center text-h5">Terms of Service</div><div class="text-right">Effective Date: 07-15-2024</div><div class="mt-2"><p>Welcome to <a href="https://lingua.community">lingua.community</a> (the "App"), operated by Leontyev and Partners LLC ("the Company," "we," "us," or "our"), a company registered in Bishkek, Kyrgyzstan. By accessing or using the App, you agree to comply with and be bound by the following terms and conditions (the "Terms"). Please read these Terms carefully before using the App. If you do not agree to these Terms, you must not use the App.</div><ol class="mt-3"><li><div>User Accounts</div><ol><li><div>Registration</div><p>Users can create accounts on the App as either a Teacher or a Student (each an "Account"). By creating an Account, you represent and warrant that the information you provide is accurate, current, and complete. You are responsible for maintaining the confidentiality and security of your Account credentials.<li><div>Types of Accounts</div><ul><li>Teachers: Users registered as Teachers can plan video meetings, upload educational content, create quizzes and tests with instant feedback, and share them with Students.<li>Students: Users registered as Students can participate in online meetings planned by Teachers and access educational content created by the Teachers.</ul><li><div>Age Restrictions and Legal Responsibilities</div><ul><li>Services are available only to and may only be used by individuals who are 18 years and older and who can form legally binding contracts under applicable law.<li>Individuals under the age of 18 but not younger than the age of 13 can use our Services only in conjunction with and under the supervision of a parent or a legal guardian. The parent or the legal guardian shall at all times be responsible for any and all activities related to the use of the Services by the aforementioned individuals.</ul></ol><li class="mt-2"><div>Online Education Services</div><ol><li><div>Features</div><ul><li>The App provides tools for individual and small group real-time sessions such as video meetings, an interactive online whiteboard, quizzes, and tests with instant feedback.</ul><li><div>Teacher Assessment</div><ul><li>The App offers tools to assess teachers\' professional qualities based on three criteria: punctuality, proven capability, and skills development.<li>Public Evaluation: The Teacher agrees to publicly display the evaluation grades they receive through students\' evaluations and the testimonials that their students share about their teaching service, regardless of whether the grades and testimonials are positive or negative. The Company does not correct testimonials and evaluation grades except the cases when the Student deliberately insults, calls names.</ul><li><div>Platform Services</div><ul><li>The Company does not provide educational services itself. Rather, <b>**lingua.community**</b> provides tools for Teachers and Students to interact.</ul></ol><li class="mt-2"><div>Financial and Methodological Independence</div><ol><li><div>Payment Policies</div><ul><li>The Company is not an intermediary in financial or methodological and disciplinary matters between Teachers and Students. The online lesson payment fee and payment policy as well as lesson cancellation policy are solely determined by the Teacher and the Student.</ul><li><div>Disagreements</div><ul><li>In the event of any disagreement between a Student and a Teacher regarding underpayment, late payment, lesson cancellation policy, or any other financial issue, the Company is not liable or responsible.</ul><li><div>Tax and Licensing Responsibilities</div><ul><li>Teachers are responsible for paying all necessary taxes and obtaining required licenses as mandated by the tax laws in their country of location. For example, teachers from Kyrgyzstan should buy a tutor patent and pay for a social fund certificate.</ul></ol><li class="mt-2"><div>Student Testimonials</div><ol><li><div>Testimonial Rights</div><ul><li>Students have the right to write testimonials about their Teacher’s service and evaluate the Teacher\'s professional quality. The Company does not correct or change the testimonials except the cases when students call names, humiliate, disgrace teacher or discriminate against group of people on ethnic, national, religious, gender bias. Any user can report such violation through Telegram messengers at <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a> or <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a> or calling directly to <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a></ul><li><div>Testimonial Format</div><ul><li>The Company will include the number of lessons taken by the Student before they wrote the testimonial and add this information to the testimonial\'s text.<br>For example, if a Student named Ruslan has taken 10 online lessons with a specific Teacher named Garry Goodson, and Ruslan wrote, "Mr. Garry Goodson is a very competent teacher. He answers all my questions and provides me with additional examples, exceptions from the rule that are not mentioned in the textbook," then the testimonial will appear on the website in the following form: "Ruslan has taken 10 lessons with Garry Goodson. Ruslan wrote, \'Mr. Garry Goodson is a very competent teacher. He answers all my questions and provides me with additional examples, and exceptions from the rule that are not mentioned in the textbook.\'"</ul></ol><li class="mt-2"><div>User Conduct</div><ol><li><div>Content Upload</div><ul><li>Users are responsible for any content they upload, share, or create using the App. The Company reserves the right to remove any content that violates these Terms or applicable laws especially if the content violates copyright, contains any kind of discrimination, including but not restricted to ethnic, gender or national basis.</ul><li><div>Prohibited Activities</div><ul><li>Copyright Violation: Teachers are prohibited from using materials and content under copyright prohibition. If a Teacher uses materials and content that violate copyright, the account of such Teacher will be terminated, and the content that violates copyright will be deleted without an opportunity to restore.<li>Users may download the content from the app but only for personal use. It is prohibited to distribute the content you uploaded from the app to the third parties.<li>Users must not use the App for any unlawful purpose or engage in any activity that disrupts or interferes with the App\'s operation.</ul><li><div>User Interaction and Personal Safety</div><p>The Company does not endorse or make any representations or warranties regarding the accuracy, completeness, and reliability of any information provided by a Teacher or a Student. lingua.community cannot confirm that each User is who they claim to be. When interacting with other Users, you should exercise caution and common sense to protect your personal safety and property, just as you would when interacting with other people you don’t know. Neither the Company nor lingua.community is responsible for the conduct, whether online or offline, of any User of the Services.<li><div>Fraud Prevention and Identity Theft</div><p>Users should only respond to communications sent through our official name channels: Telegram <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a> or <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, and WhatsApp <a href="https://wa.me/996554877853">+996 (554) 877-853</a>.<br>Any attempt to name our users from other channels claiming to represent the Company is considered a malicious attempt at identity theft.<p>Users should never provide their credit card numbers, passport ID numbers, or any other sensitive information to websites not having lingua.community as the root domain. The Company does not sell subscriptions using any other websites.</ol><li class="mt-2"><div>Fees and Payments</div><ol><li><div>Teacher Subscription Fee</div><ul><li>Teachers are charged monthly for the use of the App in the amount of 1000 KGS (Kyrgyz Soms). If the payment transaction uses a currency other than Kyrgyz Soms (KGS), the amount charged will be calculated according to the national Kyrgyz bank exchange rate at the time of the transaction.</ul></ol><li class="mt-2"><div>Intellectual Property</div><ol><li><div>Ownership</div><ul><li>The App and its entire contents, features, and functionality are owned by the Company or its licensors and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</ul><li><div>Licence</div><ul><li>Users are granted a limited, non-exclusive, non-transferable, and revocable license to use the App for personal or educational purposes in accordance with these Terms.</ul></ol><li class="mt-2"><div>Disclaimer of Warranties</div><p>The App is provided on an "as-is" and "as-available" basis. The Company makes no warranties, expressed or implied, regarding the operation of the App or the information, content, or materials included therein.<li class="mt-2"><div>Limitation of Liability</div><p>In no event shall the Company be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the App.<li class="mt-2"><div>Changes to the Terms</div><p>The Company reserves the right to modify these Terms at any time. Any changes will be effective immediately upon posting the revised Terms on the App. Your continued use of the App after the posting of the revised Terms constitutes your acceptance of the changes.<li class="mt-2"><div>Governing Law</div><p>These Terms shall be governed by and construed in accordance with the laws of the Kyrgyz Republic without regard to its conflict of law principles.<li class="mt-2"><div>Contact Information</div><p>For any questions or concerns regarding these Terms, please name us at:<br><br>Leontyev and Partners LLC<br>[Yug-2, h14]<br>Bishkek, Kyrgyzstan<br>Telegram: <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Tel: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><li class="mt-2"><div>Cookie Policy for registered and non-registered users</div><p>This Cookie Policy explains how lingua.community ("we," "us," or "our"), operated by Leontyev and Partners LLC, uses cookies and similar technologies to recognize you when you visit our website at https://lingua.community It explains what these technologies are, why we use them, and your rights to control our use of them.<ol><li><div>What Are Cookies?</div><p>Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.<li><div>Why Do We Use Cookies?</div><p>We use cookies for several reasons. Some cookies are required for technical reasons for our website to operate, and we refer to these as "essential" or "strictly necessary" cookies. Other cookies enable us to track and target the interests of our users to enhance the experience on our website. For example, we use cookies to recognize you when you return to our website to provide relevant content and detect potential security threats.<li><div>Types of Cookies We Use:</div><ol><li>Essential Cookies: These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as access to secure areas.<li>Performance and Functionality Cookies: These cookies are used to enhance the performance and functionality of our website but are non-essential to its use. However, without these cookies, certain functionality (like videos) may become unavailable.<li>Analytics and Customization Cookies: These cookies collect information that is used either in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are, or to help us customize our website for you.<li>Security Cookies: These cookies help identify and prevent security risks. We use these cookies to authenticate users and protect user data from unauthorized parties.</ol><li><div>Your Choices Regarding Cookies</div><p>You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by setting or amending your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionalities and areas of our website may be restricted.<li><div>How to Delete Cookies</div><p>If you would like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser:<ol><li>For Chrome: [Google Chrome] ( <a href="https://support.google.com/chrome/answer/95647" target="_blank">https://support.google.com/chrome/answer/95647 </a>)<li>For Internet Explorer: [Microsoft Internet Explorer] ( <a href="https://support.microsoft.com/kb/278835" target="_blank">https://support.microsoft.com/kb/278835 </a>)<li>For Firefox: [Mozilla Firefox] ( <a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored" target="_blank">https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored </a>)<li>For Safari: [Apple Safari] ( <a href="https://support.apple.com/guide/safari/sfri11471/mac" target="_blank">https://support.apple.com/guide/safari/sfri11471/mac </a>)</ol><p>Note that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.<li><div>Changes to This Cookie Policy</div><p>We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal, or regulatory reasons. Please revisit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.</ol></ol><p class="mt-2">Leontyev and Partners LLC<br>[Yug-2, h14]<br>Bishkek, Kyrgyzstan<br>Telegram: <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Tel: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><p>By using our website, you acknowledge that you have read, understood, and agree to be bound by this Cookie Policy.</div>',
    },
    privacyPolicy: {
      content:
        '<div class="mx-2 my-4"><div class="text-center text-h5">Privacy Policy</div><div class="text-right">Effective Date: 07-15-2024</div><div class="mt-2"><p>Welcome to Lingua Community ("we", "our", "us"). This Privacy Policy explains how Leontev and Partners LLC, located at Kyrgyzstan, Bishkek, Yug-2, h14 ("Company"), collects, uses, discloses, and safeguards your information when you visit our website <a href="https://lingua.community">lingua.community</a> and use our services. By using our website, you agree to the terms of this Privacy Policy. The current Application Privacy Policy is inherent to Application Terms and Service Agreement.</div><ol class="mt-3"><li><div>Information We Collect</div><ul><li><div>Personal Data</div><p>When you register as a teacher or a student using your Google account, we collect your full name, profile picture, and email address. These become publicly accessible on our platform.<li><div>Teacher-Specific Data</div><p>Teachers provide educational services and are graded by students based on evaluation criteria such as punctuality, competency, skills developed and others. These grades are publicly available.<li><div>Testimonials</div><p>We collect and display testimonials about the educational services provided within the platform. The teacher agrees to accept testimonials from the students without changing their content. Testimonials include the full names of the teacher and student, and the number of lessons conducted before the testimonial was published. The number of lessons conducted inside the website is automatically tracked and stored inside your personal profile. The number of lessons conducted with specific student becomes publicly visible only when you receive a testimonial from the student.<li><div>Usage Data</div><p>We collect information about your interactions with our website, such as the pages you visit, the time and date of your visits, the number of lessons conducted, your IP address and location, and other diagnostic data.<li><div>Cookies and Similar Technologies</div><p>We use cookies to determine your IP address and location, and to improve the overall user experience. These technologies help us understand how you interact with our services and provide a better experience.</ul><li><div>How We Use Your Information</div><p>We use the information we collect to:<ul><li>Provide and maintain our services<li>Display teacher profiles and their grades to non-registered users<li>Display testimonials with names and lesson counts<li>Notify you about changes to our services<li>Provide customer support<li>Analyze usage of our website to improve our services<li>Detect, prevent, and address technical issues<li>Comply with legal obligations and enforce our terms</ul><li><div>Sharing Your Information</div><p>We do not sell or share your personal information with third parties except:<ul><li>With your consent<li>Display teacher profiles and their grades to non-registered users<li>To comply with legal obligations<li>To protect and defend our rights and property<li>With service providers to perform services on our behalf<li>In connection with any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company</ul><li><div>Publicly Accessible Information</div><ul><li>Teacher profiles, including full names, profile pictures, grades, and testimonials, are publicly accessible to any user.<li>Testimonials expose the full names of both the teacher receiving the testimonial and the student writing the testimonial, along with the number of lessons conducted.</ul><li><div>Security of Your Information</div><p>We use administrative, technical, and physical security measures to protect your personal information. However, no method of transmission over the internet or electronic storage is 100% secure.<li><div>Your Data Protection Rights</div><p>Depending on your location, you may have the following rights regarding your personal data:<ul><li>The right to access<li>The right to rectification<li>The right to erasure<li>The right to restrict processing<li>The right to data portability<li>The right to object</ul><li><div>Cookies and Similar Technologies Policy</div><p>We use cookies and similar technologies to:<ul><li>Determine your IP address and location<li>Improve user interaction and experience on our website</ul><p>You can manage your cookie preferences through your browser settings. For more information on how to control cookies and similar technologies, please refer to our <a href="/terms-and-conditions-agreement">[Cookie Policy]</a><li><div>Third-Party Services</div><p>Our services may contain links to third-party websites or services, including Google. We do not control these third-party sites and are not responsible for their privacy practices. We recommend you review the privacy policies of these third-party services.<li><div>Children\'s Privacy</div><p>Our services are not intended for individuals under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information.<li><div>Changes to This Privacy Policy</div><p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" at the top.<li><div>Contact Us</div><p>If you have any questions about this Privacy Policy, please name us at <a href="mailto:skypestudy.org@gmail.com">skypestudy.org@gmail.com</a> and/or WhatsApp <a href="https://wa.me/996554877853">+996 (554) 877-853</a></ol><p class="mt-2">Leontyev and Partners LLC<br>[Yug-2, h14]<br>Bishkek, Kyrgyzstan<br>Telegram: <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Tel: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><p>By using our website, you acknowledge that you have read, understood, and agree to be bound by this Cookie Policy.</div>',
    },
  },
  messages: {
    lessonDeleted: "Lesson successfully deleted",
    audioDeleted: "Audio successfully deleted",
    attachmentDeleted: "Attachment successfully deleted",
    exerciseDeleted: "Exercise successfully deleted",
    exerciseSaved: "Exercise successfully saved",
    lessonCreated: "Lesson successfully created",
    quizDeleted: "Quiz successfully deleted",
    quizUnlinked: "Quiz successfully unlinked",
    quizCreated: "Quiz successfully created",
  },
  buttons: {
    cancel: "Cancel",
    ignore: "Ignore",
    ok: "OK",
    delete: "Delete",
    unlink: "Unlink",
    create: "Create",
    save: "Save",
    update: "Update",
    check: "Check",
    link: "Link",
    submit: "Submit",
    confirm: "Confirm",
    quit: "Quit",
    back: "Back",
    previous: "Previous",
    next: "Next",
    preview: "Preview",
    edit: "Edit",
    view: "View",
    join: "Join",
    close: "Close",
  },
  editor: {
    enterUrl: "Enter a URL",
    enterImageUrl: "Enter an image URL",
    enterVideoUrl: "Enter a video URL",
    unlink: "Unlink",
    link: "Link",
    add: "Add",
    title: "Title",
    submit: "Submit",
    cancel: "Cancel",
  },
  common: {
    all: "All",
    confirmDialog: "Are you sure to make this operation?",
  },
  date: {
    months: {
      short: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      full: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    },
  },
  fileBrowser: {
    delete: {
      title: "Delete",
      description:
        "Are you sure you want to delete this <b>{type}</b>?<br><em>{baseName}</em>",
      suffix: {
        folder: "folder",
        file: "File",
      },
    },
    cancel: "Cancel",
    select: "Select",
    yes: "Yes",
    selectFolderOrFile: "Select a folder or a file",
    file: "File",
    size: "Size",
    noFilesOrFoldersFound: "No files or folders found",
    folderIsEmpty: "The folder is empty",
    upTo: "Up to: {value}",
    createFolder: "Create folder",
    uploadFiles: "Upload files",
    collapseAll: "Collapse All",
    uploadTo: "Upload to:",
    maxFilesCount: "Max files count: {value}",
    maxFileSize: "Max file size: {value}",
    addFiles: "Add files",
    clear: "Clear",
    upload: "Upload",
  },
  camera: {
    errors: {
      CAMERA_IS_OFF: {
        title: "Camera is off",
      },
      CAMERA_PERMISSION_ERROR: {
        title: "Camera permission was not granted",
        description:
          "To fix this problem please grant it in your browser and after reload the page",
      },
      CAMERA_UNAVAILABLE_ERROR: {
        title: "Camera is unavailable",
        description:
          "While requesting camera access browser couldn't provide access to camera",
      },
      MIC_PERMISSION_ERROR: {
        title: "Mic permission was not granted",
        description:
          "To fix this problem please grant it in your browser and after reload the page",
      },
      MIC_UNAVAILABLE_ERROR: {
        title: "Mic is unavailable",
        description:
          "While requesting mic access browser couldn't provide access to mic",
      },
    },
  },
  selectContacts: {
    form: {
      query: {
        placeholder: "Enter name of your contacts",
      },
    },
  },
  time: {
    startsIn: "Starts <b>{time}</b>",
    endsIn: "Ends <b>{time}</b>",
    ended: "Ended <b>{time}</b>",
    cancelled: "Cancelled <b>{time}</b>",
  },
  targetLanguages: {
    english: "English",
    russian: "Russian",
    kyrgyz: "Kyrgyz",
    kazakh: "Kazakh",
    uzbek: "Uzbek",
    turkmen: "Turkmen",
    armenian: "Armenian",
  },
  languageLevels: {
    A1: "Beginner",
    A2: "Elementary",
    B1: "Intermediate",
    B2: "Upper Intermediate",
    C1: "Advanced",
    C2: "Proficient",
  },
  specialityGroups: {
    beginner: {
      title: "For Beginners",
      items: {
        general: {
          title: "General",
          shortTitle: "General",
        },
        preschoolers: {
          title: "Preschoolers",
          shortTitle: "Preschoolers",
        },
        schoolChildrenPrimary: {
          title: "Primary Schoolchildren",
          shortTitle: "Primary School",
        },
      },
    },
    intermediate: {
      title: "Intermediate",
      items: {
        interview: {
          title: "Interview Preparation (Visa / Work)",
          shortTitle: "Interview Prep",
        },
        speakingPractice: {
          title: "Speaking Practice (Fluency & Confidence)",
          shortTitle: "Speaking Practice",
        },
        examPreparation: {
          title: "Exam Preparation (OGE / UNT / ORT)",
          shortTitle: "Exam Prep",
        },
        schoolChildrenSecondary: {
          title: "Secondary Schoolchildren",
          shortTitle: "Secondary School",
        },
      },
    },
    advanced: {
      title: "Advanced",
      items: {
        business: {
          title: "Business English",
          shortTitle: "Business English",
        },
        aviation: {
          title: "Aviation English",
          shortTitle: "Aviation English",
        },
        medicine: {
          title: "Medical English",
          shortTitle: "Medical English",
        },
        examPreparation: {
          title: "Exam Preparation (IELTS / TOEFL / SAT)",
          shortTitle: "Exam Prep",
        },
        academicEnglish: {
          title: "Academic English (University)",
          shortTitle: "Academic English",
        },
        technicalEnglish: {
          title: "Technical English (IT & Engineering)",
          shortTitle: "Technical English",
        },
        legalEnglish: {
          title: "Legal English",
          shortTitle: "Legal English",
        },
      },
    },
  },
};
